import styled from "styled-components";
import { Dropdown as BaseDropDown } from "antd";

const Dropdown = styled(BaseDropDown).attrs(({ width }) => ({
  width: width || "unset",
}))`
  width: ${({ width }) => width};
`;

export default Dropdown;
